import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Grid, CircularProgress } from '@mui/material';
import { Article, ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import NewsCard from '../News/NewsCard';
import optimizedNewsApi from '../../services/optimizedNewsApi';

const MovieNewsSection = ({ movieId, movieName }) => {
  const navigate = useNavigate();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (movieId) {
      loadMovieNews();
    }
  }, [movieId]);

  const loadMovieNews = async () => {
    console.log('[MovieNewsSection] Loading news for movieId:', movieId, 'Type:', typeof movieId);
    setLoading(true);
    try {
      const result = await optimizedNewsApi.getMovieNews(movieId);
      console.log('[MovieNewsSection] News result:', result);
      console.log('[MovieNewsSection] Found', result.items?.length || 0, 'articles for this movie');
      if (result.success) {
        setNews(result.items || []);
      }
    } catch (error) {
      console.error('[MovieNewsSection] Failed to load movie news:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewAll = () => {
    navigate(`/news?movie=${movieId}`);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={3}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (news.length === 0) {
    return null;
  }

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center" gap={1}>
          <Article color="primary" />
          <Typography variant="h6" fontWeight="bold">
            Latest News
          </Typography>
        </Box>
        {news.length > 0 && (
          <Button
            size="small"
            endIcon={<ArrowForward />}
            onClick={handleViewAll}
          >
            View All ({news.length})
          </Button>
        )}
      </Box>

      <Grid container spacing={2}>
        {news.slice(0, 3).map((article) => (
          <Grid item xs={12} key={article.id}>
            <NewsCard
              news={article}
              onView={(article) => navigate(`/news/${article.id}`)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MovieNewsSection;
